<div class="container-fluid mt-3">
  <h2>Menu Edit</h2>

  <ng-container *ngIf="metaMenu$ | async; let metaMenu">
    <div class="mt-3">

      <table class="table table-striped">
        <thead>
        <tr>
          <th *ngFor="let colIdx of columnNumbers">
            <lib-menu-header-view [menu]="getMenu(metaMenu, colIdx)"
                                  (menuAdded)="onMenuAdded(metaMenu, colIdx)"
                                  (menuDeleted)="onMenuDeleted(metaMenu, colIdx)"
                                  (menuMoved)="onMenuMove(metaMenu, colIdx, $event)"
            >
            </lib-menu-header-view>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let rowIdx of rowNumbers">
          <td *ngFor="let colIdx of columnNumbers">
            <lib-menu-item-view
              [menu]="getMenu(metaMenu, colIdx)"
              [menuItem]="getMenuItem(metaMenu, colIdx, rowIdx)"
              (menuItemAdded)="onMenuItemAdded(metaMenu, colIdx, rowIdx, $event)"
              (menuItemDeleted)="onMenuItemDeleted(metaMenu, colIdx, rowIdx)"
              (menuItemMoved)="onMenuItemMoved(metaMenu, colIdx, rowIdx, $event)"
              (menuItemMenuMoved)="onMenuItemMenuMoved(metaMenu, colIdx, rowIdx, $event)"
            >
            </lib-menu-item-view>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="d-flex">
        <div class="flex-grow-1"></div>
        <button class="btn btn-outline-primary me-2" (click)="onBack(getMenuItem(metaMenu, 0, 0))">Back</button>
        <button class="btn btn-primary" (click)="onSaveMetaMenu(metaMenu)">Save</button>
      </div>
    </div>
  </ng-container>
</div>
